const page = `

{settings}
document.title: Ivar Arpi
og.title: Ivar Arpi
og.image: http://quickshot.imgix.net/opinionsbildaren-ivar-arpi/ArpiStill5.png?w=1000&auto=format
og.twitterImage: http://quickshot.imgix.net/opinionsbildaren-ivar-arpi/ArpiStill5.png?h=120&w=120&auto=format&fit=crop
og.description: Han är kommunisten som bytte politisk sida. Ledarskribenten Ivar Arpi väcker starka känslor på vänsterkanten och debatterar helst frågor som rör invandring och integration.
og.url: http://pejl.svt.se/opinionsbildaren-ivar-arpi
siteCatalyst.name: opinionsbildaren-ivar-arpi
siteCatalyst.category: lyxartikel
{}
[+page]
{.div}
  style.position:relative
  style.backgroundColor: black
  style.color:white
  style.height: 100%;
  style.marginBottom: -18px;
  [.+content]
  
  
    {.div}
      style.minHeight:70vh
      style.position:relative
      style.paddingBottom:25px
      [.+content]
        {.div}
          style.position:relative
          style.width: 300px
          style.height:45px
          style.top:20px
          style.backgroundImage: url('http://quickshot.imgix.net/annika-beijbom/ob-1-rad-vit-ht_720.png')
          style.backgroundPositionY: 50%
          style.backgroundPositionX: 0%
          style.backgroundSize: cover
          [.+content]
          []
        {}
        
        luft:-50
          rubrik3: Ivar Arpi
          
          {.video}
            id:13794736?autostart=true
            storlek:wide
          {}
          {.citat}    
            citat: Jag vill gärna vara där det är obekvämt, där det är obehagligt att vara, där det är känsligt, där det är frågor som är tabu.
            cstyle.color:#ddd
          {}
               
      []
    {}
    
    
   
   
 
    {.div}
      style.minHeight: calc(100vh - 40px)
      style.backgroundImage: url('http://quickshot.imgix.net/opinionsbildaren-ivar-arpi/ArpiStill1.png?h=1200&w=1200&fit=crop&auto=format&q=45&cs=tinysrgb')
      style.backgroundRepeat: no-repeat
      style.backgroundSize: cover
      style.backgroundPosition: 50% 20%
      [.+content]
      []
    {}
    
    
    
    
    {.div}
      style.minHeight: calc(100vh - 40px)
      style.backgroundColor: #111
      style.display:flex
      style.flexDirection:column
      style.justifyContent:center
      [.+content]
        {.div}
          [.+content]
          
            mellanrubrik: KOMMUNISTEN
Han är kommunisten som bytte politisk sida. Ledarskribenten Ivar Arpi väcker starka känslor på vänsterkanten. 
– Jag kallade mig själv för kommunist, min familj var röd, mina vänner var röda och alla vi umgicks med var röda. Vänsterns värderingar sitter i ryggmärgen, säger han.
Ivar är född och uppvuxen i landshövdingehus i Majorna i Göteborg, med matlag på gården och stark vänsterideologi.
Han minns särskilt ett tillfälle då en pappa på gården klippte till en av de andra papporna.
– När jag frågade mamma varför, sa hon att det berodde på att den arga pappan inte tyckte om borgare. När jag frågade vad en borgare var, fick jag till svar att det var en som röstade på Socialdemokraterna. 
I samband med kravallerna i Göteborg 2001, då han demonstrerade mot George W Bush, började Ivar ifrågasätta sin ideologi.Och efter terrorattacken mot World Trade Center vacklade han ännu mer i sin tro.
I dag är det få som känner till Ivar Arpis politiska bakgrund. Som högerdebattör ses han ofta som ond och många av hans gamla vänner har vänt honom ryggen.
            luft:
          []
        {}
      []
    {}
    
    
    
    {.div}
      style.position:relative
      style.paddingTop:24px
      style.paddingBottom:24px
      [.+content]
           
        {.video}
          id:13794788
          storlek:wide

        {}
        {.citat}    
          citat: Mina närmaste vänner är kompisar med mig TROTS att jag är ledarskribent på Svenska Dagbladet – inte på grund av det.
          cstyle.color:#ddd
        {}
      []
    {}
    

   
   {.div}
      style.minHeight: calc(100vh - 40px)
      style.backgroundImage: url('http://quickshot.imgix.net/opinionsbildaren-ivar-arpi/ArpiStill2.png?h=1200&w=1200&fit=crop&auto=format&q=45&cs=tinysrgb')
      style.backgroundRepeat: no-repeat
      style.backgroundSize: cover
      style.backgroundPosition: 40% 100%
      [.+content]
      []
    {}
    
    
    
    {.div}
      style.minHeight: calc(100vh - 40px)
      style.backgroundColor: #111
      style.display:flex
      style.flexDirection:column
      style.justifyContent:center
      [.+content]
        {.div}
          [.+content]
          
            mellanrubrik: OPINIONSBILDAREN

Ivar Arpi är näst äldst i en syskonskara om fyra. Pappa är journalist och mamma lärare. Som liten var Ivar sportintresserad, hade svårt att sitta still och hamnade ofta i slagsmål.
– En gammal kompis, som i dag är Kapten Röd, sa någon gång att jag nog fick skylla mig själv lite eftersom jag aldrig kunde hålla käften. Så var det nog, och så är det nog fortfarande, säger han.
Som opinionsbildare ser Ivar migrationsfrågan - och hur Sverige och Europa ska hantera den - som en ödesfråga. En politiskt vattendelare.
– Det har blivit den viktigaste frågan för att kategorisera var människor står. På många sätt har den och relaterade frågor ersatt  höger- eller vänsterskalan.
I samband med traumatiska händelser, som terrordåd eller uppmärksammade dödsfall, får Ivar ta emot mycket hot och hat. Ibland utan att ens ha sagt ett ord om händelsen.
Av sina politiska motståndare hölls han till exempel personligt ansvarig både för skolattacken i Trollhättan och för att den lille kurdiske pojken Aylan Kurdi drunknade.

            luft:

          []
        {}
      []
    {}
    
    
    
    {.div}
      style.position:relative
      style.paddingTop:24px
      style.paddingBottom:24px
      [.+content]
           
        {.video}
          id:13794756
          storlek:wide
        {}
        {.citat}    
          citat: När folk hatar mot mig eller mot folk på min kant, högerkanten, gör de det ofta i sitt eget namn – det är jurister, journalister, akademiker – det ser annorlunda ut.
          cstyle.color:#ddd
        {}
      []
    {}
    
    
    
    
    
    {.div}
      style.minHeight: calc(100vh - 40px)
      style.backgroundImage: url('http://quickshot.imgix.net/opinionsbildaren-ivar-arpi/ArpiStill3.png?h=1200&w=1200&fit=crop&auto=format&q=45&cs=tinysrgb')
      style.backgroundRepeat: no-repeat
      style.backgroundSize: cover
      style.backgroundPosition: 50% 50%
      [.+content]
      []
    {}
    
    
    {.div}
      style.minHeight: calc(100vh - 40px)
      style.backgroundColor: #111
      style.display:flex
      style.flexDirection:column
      style.justifyContent:center
      [.+content]
        {.div}
          [.+content]
          
            mellanrubrik: VINNARSKALLEN
Trots sin framträdande position som ledarskribent har Ivar haft svårt med den offentliga biten - att gå från en okänd tillvaro till att bli mer av en symbol än en riktig människa.
– Det finns en press hos många i Sverige att ta avstånd från folk med andra åsikter, säger han. Man använder i debatten framträdande personer för att visa samhörighet och markera avstånd. Denna polarisering gör oss helt klart dummare.
När han blir intervjuad i internationella medier ses han ibland till och med som vänster, än som någon som på hemmaplan är känd för att vara höger.
– Det visar väl bara att vi är ett litet land med en märklig mittposition. Det var inte så länge sedan sossarna hade den striktaste invandringspolitiken. Men minnet är kort.
Ivars vinnarskalle är något som följt honom genom livet, oavsett om det handlar om sällskapsspel eller politiska debatter. Planering och förberedelse är viktigt, menar han.
Under skolåren var han en framgångsrik schackspelare. Med sitt strategiska tänkande kammade han hem fina pokaler till Kungsladugårdsskolan i Majorna.
SVT Opinion utmanade den gamla schackmästaren i ett parti.

            
            luft:

          []
        {}
      []
    {}
    
    
    
    
     {.div}
      style.position:relative
      style.paddingTop:24px
      style.paddingBottom:24px
      [.+content]
           
        {.video}
          id:13794800
          storlek:wide
        {}
        {.citat}    
          citat: En likhet mellan ett schackparti och politiska debatter är att den som är bäst förberedd kommer att vinna.
          cstyle.color:#ddd
        {}
      []
    {}
    
    
     {.div}
      style.minHeight: calc(100vh - 40px)
      style.backgroundImage: url('http://quickshot.imgix.net/opinionsbildaren-ivar-arpi/ArpiStill4.png?h=1200&w=1200&fit=crop&auto=format&q=45&cs=tinysrgb')
      style.backgroundRepeat: no-repeat
      style.backgroundSize: cover
      style.backgroundPosition: 50% 50%
      [.+content]
      []
    {}
    
    
     {.div}
      style.minHeight: calc(100vh - 40px)
      style.backgroundColor: #111
      style.display:flex
      style.flexDirection:column
      style.justifyContent:center
      [.+content]
        {.div}
          [.+content]
          
            mellanrubrik: HUNDÄGAREN
Ivar beskriver sig själv som en person som njuter av diskussion och att röra om i grytan. Trots det hat och hot han ofta får ta emot ser han ändå ett värde i konflikten som skapas.
– Det är väl min syn på demokrati. En konstruktiv konflikt leder saker framåt. Man tvingas slipa argumenten och ta reda på hur det faktiskt ligger till. När jag gör mitt jobb som bäst så stimulerar jag i alla fall tanken hos människor, oavsett om de håller med eller inte.
På sin fritid hinner han inte med lika mycket konflikter. Det mesta av tiden går åt till familjen. Ivar blev nyligen pappa för andra gången.
Men däremellan hinner han med en del träning. Ivar har precis färdigställt ett gym nere i källaren i sin bostadsförening, en plats för boxning och styrketräning.
– Dessutom har jag min lilla mops Bibbi som jag tar ut på långpromenader. Jag har blivit lite av en "crazy dog man" på äldre dar, säger han och skrattar.


            luft:

          []
        {}
      []
    {}
    
    
    
     {.div}
      style.position:relative
      style.paddingTop:24px
      style.paddingBottom:24px
      [.+content]
           
        {.video}
          id: 13794804
          storlek:wide
        {}
        {.citat}    
          citat: Det är ett av de få naturliga sätten att träffa andra människor på – att gå ut med hunden och träffa andra hundar.
          cstyle.color:#ddd
        {}
      []
    {}
    
    
        
   
    
    
    {.div}
        style.backgroundColor: #eee
        style.color:#111
        style.maxWidth: 600px
        style.padding: 1px 12px
        style.margin: 24px auto 0
        [.+content]
           mellanrubrik: OM IVAR ARPI 
           
          {.bild}
            fil:opinionsbildaren-ivar-arpi/ArpiStill5.png
            storlek:m
            imgix.fp-y:0.3
          {}
          
          [Namn:] Ivar Axel Arpi.
          [Född:] 21 november 1982 i Göteborg.
          [Familj:] Hustru , två barn och en mops.
          [Bor:] Uppsala.
          [Gör:] Politisk skribent och borgerlig debattör. Arbetar som ledarskribent på Svenska Dagbladet. Tidigare ledarskribent på Göteborgs-Posten, Hallandsposten och Liberala Nyhetsbyrån. Tidigare redaktör för Axess magasin och det borgerliga samhällsmagasinet Neo.
          [Beskriv dig själv:] Njuter av diskussion och konstruktiva konflikter. När jag gör mitt jobb som bäst stimulerar jag tanken hos människor.
          [På fritiden:] Umgås allra helst med familjen. Helst långpromenader i naturen där både mops och barn kan springa fritt. Men flyr gärna korta stunder för att träna boxning eller styrketräning.  
          [Oanade talanger:] Var en gång i tiden väldigt duktig på att spela schack. Tagit hem massor av priser för min gamla grundskola i Göteborg. 
          [Annorlunda tävlingar:] Den brittiska författaren Douglas Coupland utlyste i konstprojektet "I am Vincent" år 2016 den person i världen som var mest lik konstnären Vincent van Gogh. Jag var länge i ledningen, men blev helt rättvist slagen på mållinjen.
          
          luft:
        []
      {}[
      
      
      
    
    
    luft:200
    
    rubrik5:Reporter: Magnus Nilsson
    rubrik5:Fotograf: Åke Wehrling
    rubrik5:[SVT Opinion | http://www.svt.se/opinion/om-opinionsbildaren | white | target:_self  ]
    
    {.sharebuttons}
    title: Ivar Arpi
    url: http://pejl.svt.se/opinionsbildaren-ivar-arpi/
    {}
       
    luft:100
   
  []
{}



[]
`;

export default page;





/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/data/articles/opinionsbildaren-ivar-arpi.js
 **/